import client from "libs/HttpClient";

/**
 * Service class for handling Dashboard.
 */
class DashboardService {
  /**
   * get Dashboard based on the provided request.
   *
   * @param request - The request parameters for getting a Dashboard.
   * @returns A Promise that resolves to the Axios response for the update Dashboard request.
   */
  static getDashboard(request: any) {
    return client.get("admin/dashboard/get-user-detail", request);
  }
}

export { DashboardService };
